export default {
    props: {
        provisioners: {
            type: [Array, Object],
            default: () => []
        },
        // 'explicit' — списання з обраної партії; 'fifo' — по всіх партіях товару.
        mode: {
            type: String,
            default: 'explicit'
        },
        productTitle: {
            type: String,
            default: ''
        },
        pending: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form:{
                quantity:0,
                reason: '',
            }
        }
    },
    methods: {
        closePopup() {
            this.$emit('closePopup')
        },
        confirmWriteOff() {
            if (this.pending) {
                return;
            }
            this.$emit('confirmWriteOff', this.form)
        },
        cancelRemove() {
            this.$emit('closePopup')
        }
    }
}
